const anonymousMediaKeys = new Map<string, string>();
export const MAX_ANONYMOUS_MEDIA_KEYS = 500;

function createOpaqueMediaId() {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function resolveMediaCorrelationKey({
  assetId,
  uploadAttemptId,
  urls = [],
  fileName,
}: {
  assetId?: string | null;
  uploadAttemptId?: string | null;
  urls?: Array<string | null | undefined>;
  fileName?: string | null;
}) {
  if (assetId) {
    return `asset:${assetId}`;
  }

  if (uploadAttemptId) {
    return `upload:${uploadAttemptId}`;
  }

  const localIdentity =
    urls.find((url): url is string => Boolean(url)) || fileName || null;
  if (localIdentity) {
    let key = anonymousMediaKeys.get(localIdentity);
    if (!key) {
      key = `media:${createOpaqueMediaId()}`;
      if (anonymousMediaKeys.size >= MAX_ANONYMOUS_MEDIA_KEYS) {
        const oldestIdentity = anonymousMediaKeys.keys().next().value;
        if (oldestIdentity !== undefined) {
          anonymousMediaKeys.delete(oldestIdentity);
        }
      }
      anonymousMediaKeys.set(localIdentity, key);
    }
    return key;
  }

  return `media:${createOpaqueMediaId()}`;
}
